import { Children, FC, Fragment, isValidElement, ReactNode } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { SidebarNavSectionItem } from "./SidebarNavSection";
import styles from "./styles.module.scss";

/** The `SidebarNav` component properties. */
export interface SidebarNavProps {

  /**
   * The navigation ID.
   * @deprecated ID is no longer used in nav sections.
   */
  readonly id?: string;

  /** The sidebar navigation test ID. */
  readonly testId?: string;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The in-context sidebar navigation component. */
export const SidebarNav: FC<SidebarNavProps> = (props) => {
  const { testId, children } = props;

  const validElements = Children.map(children, (child) => {
    if (isValidElement(child)) return child;
    return null;
  })?.filter((child) => !!child);

  return (
    <Stack className={styles.SidebarNav} testId={testId} spacing="medium">
      {validElements?.map((element, index) => {

        let hasSeparator = index < (validElements.length - 1);
        const nextItem = validElements[index + 1];

        if (element.type === SidebarNavSectionItem && nextItem?.type === SidebarNavSectionItem)
          hasSeparator = false;

        return (
          <Fragment key={index}>
            {element}
            {(hasSeparator) && <div className="separator" />}
          </Fragment>
        );
      })}
    </Stack>
  );
};
